module.exports = __webpack_public_path__ + "img/p61-online-platform.5eb71c78.jpg";